module.exports = __webpack_public_path__ + "img/avatar5.7b916d6c.png";